import { gql } from '@apollo/client'

export const FrgUserForLink = gql`
  fragment FrgUserForLink on UserType {
    id
    firstName
    lastName
    username
    logo
    color
  }
`

export const GET_ALL_USERS = gql`
  ${FrgUserForLink}
  query GetAllUsers(
    $offset: Int
    $first: Int
    $activeProjects: String
    $isDriver: Boolean
    $q: String
    $orderBy: String
    $order: String
    $isActive: Boolean
    $company: ID
  ) {
    allUsers(
      activeProjects: $activeProjects
      isDriver: $isDriver
      q: $q
      order: $order
      orderBy: $orderBy
      offset: $offset
      first: $first
      isActive: $isActive
      company: $company
    ) {
      totalCount
      edges {
        node {
          ...FrgUserForLink
          email
          phoneNumber
          isMaster
          isAdmin
          isSuperuser
          isActive
          companyRoles {
            id
            name
          }
          teams {
            edges {
              node {
                id
                name
              }
            }
          }
          userprojectSet {
            edges {
              node {
                id
                isSuper
                project {
                  id
                  name
                }
              }
            }
          }
          company {
            id
            name
          }
          jobtitle {
            id
            title
          }
        }
      }
    }
  }
`

const FrgUser = gql`
  ${FrgUserForLink}
  fragment FrgUser on UserType {
    ...FrgUserForLink
    email
    phoneNumber
    isActive
    language
    datetimeFormatLocale
    themePreference
    company {
      id
    }
    isAdmin
    isMaster
    isDemo
    isReseller
    jobtitle {
      id
      title
      pendingTitle
    }
    userprojectSet {
      edges {
        node {
          project {
            name
          }
          apiKey
        }
      }
    }
    companyRoles {
      id
      name
    }
  }
`

export const GET_USER = gql`
  ${FrgUser}
  query GetUser($id: ID!) {
    user(id: $id) {
      ...FrgUser
    }
  }
`

export const UPDATE_USER = gql`
  ${FrgUser}
  mutation UpdateUser(
    $userId: ID!
    $phoneNumber: String
    $firstName: String!
    $lastName: String!
    $logo: String
    $language: String!
    $isMaster: Boolean
    $datetimeFormatLocale: String!
    $color: String
  ) {
    updateUser(
      selfId: $userId
      phoneNumber: $phoneNumber
      firstName: $firstName
      lastName: $lastName
      language: $language
      logo: $logo
      isMaster: $isMaster
      datetimeFormatLocale: $datetimeFormatLocale
      color: $color
    ) {
      user {
        ...FrgUser
      }
    }
  }
`

// PRODUCT-154: dedicated self-only quick toggle. Separate from UPDATE_USER,
// which nukes the caller's logo when invoked without one.
export const UPDATE_MY_THEME_PREFERENCE = gql`
  mutation UpdateMyThemePreference($themePreference: String!) {
    updateUserThemePreference(themePreference: $themePreference) {
      user {
        id
        themePreference
      }
    }
  }
`

export const UPDATE_USER_COMPANY_ROLES = gql`
  ${FrgUser}
  mutation UpdateUserCompanyRoles($userId: ID!, $roleIds: [ID!]!) {
    updateUserCompanyRoles(userId: $userId, roleIds: $roleIds) {
      user {
        ...FrgUser
      }
    }
  }
`

export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id) {
      success
    }
  }
`

export const MUTATION_RESEND_INVITATION = gql`
  mutation MutationResendInvitation($userProjectId: ID!) {
    resendInvitation(userId: $userProjectId) {
      status
    }
  }
`

export const MUTATION_INVITE_USER_EXTENDED = gql`
  mutation MutationInviteUserExtended(
    $emails: [String!]!
    $companyId: ID!
    $projectIds: [ID!]!
    $isSuper: Boolean!
    $isMaster: Boolean!
    $roleId: ID
    $teamId: ID
    $useSso: Boolean
    $haulerId: ID
  ) {
    inviteUsers(
      emails: $emails
      projectIds: $projectIds
      isMaster: $isMaster
      isSuper: $isSuper
      companyId: $companyId
      roleId: $roleId
      teamId: $teamId
      useSso: $useSso
      haulerId: $haulerId
    ) {
      users {
        id
      }
    }
  }
`

export const GET_ALL_USERS_BY_IDS = gql`
  ${FrgUserForLink}
  query GetAllUsersByIds($ids: [ID], $skip: Boolean = false) {
    allUsers(ids: $ids) @skip(if: $skip) {
      edges {
        node {
          ...FrgUserForLink
        }
      }
    }
  }
`
